import { render, staticRenderFns } from "./analyticsStockItemDashboard.vue?vue&type=template&id=204725e7&"
import script from "./analyticsStockItemDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsStockItemDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports